// extracted by mini-css-extract-plugin
export default {"head":"skills_head__2F0Lz","background":"skills_background__wy7lE","main":"skills_main__8+Brx","gif":"skills_gif__aCTva","skill":"skills_skill__ZO7mf"};